const portfolioData = [
  {
    id: "aurora-branding",
    title: "Aurora Skincare",
    category: "Branding",
    description:
      "Identidad visual completa para una marca de cosmética natural. Logotipo, paleta cromática, packaging y guía de marca.",
    imageUrl:
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&auto=format&fit=crop&q=80",
    linkText: "Ver caso",
  },
  {
    id: "nova-web",
    title: "Nova Arquitectos",
    category: "Web Design",
    description:
      "Sitio web minimalista para un estudio de arquitectura. Diseño responsive con portfolio interactivo.",
    imageUrl:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&auto=format&fit=crop&q=80",
    linkText: "Ver caso",
  },
  {
    id: "viento-social",
    title: "Viento Coffee",
    category: "Social Media",
    description:
      "Estrategia visual y contenido para redes sociales. Grilla de Instagram, stories y templates reutilizables.",
    imageUrl:
      "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&auto=format&fit=crop&q=80",
    linkText: "Ver caso",
  },
  {
    id: "pulso-editorial",
    title: "Revista Pulso",
    category: "Editorial",
    description:
      "Diseño editorial para revista cultural independiente. Maquetación, tipografía y dirección de arte.",
    imageUrl:
      "https://images.unsplash.com/photo-1586075010923-2dd4570fb338?w=800&auto=format&fit=crop&q=80",
    linkText: "Ver caso",
  },
  {
    id: "terra-packaging",
    title: "Terra Orgánica",
    category: "Packaging",
    description:
      "Sistema de packaging sustentable para línea de productos orgánicos. Diseño estructural y gráfico.",
    imageUrl:
      "https://images.unsplash.com/photo-1636955816868-fcb881e57954?w=800&auto=format&fit=crop&q=80",
    linkText: "Ver caso",
  },
  {
    id: "lumina-uxui",
    title: "Lumina Fintech",
    category: "UX/UI Design",
    description:
      "Rediseño de app bancaria. Investigación de usuarios, wireframes, prototipos y sistema de diseño.",
    imageUrl:
      "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&auto=format&fit=crop&q=80",
    linkText: "Ver caso",
  },
];

export default portfolioData;
